



























































import { Actor, ActorTypes } from '@/data/models/actor.model';
import { Search } from '@/data/models/search.model';
import { CrudService } from '@/data/services/crud.service';
import { ClassType } from 'class-transformer/ClassTransformer';
import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

@Component({
	components: {
		ValidationObserver,
		ValidationProvider
	}
})
export default class SelectAttore extends Vue{
	@Inject('CrudService') actorCrudService !: CrudService<Actor>;

	@Prop() entity!: string;
	@Prop() redirect!: string;

	advancedSearch = new Search('actor');
	actorSelected: Actor | null = null;
	actorClass: ClassType<Actor> = Actor;

	constructor() {
		super();
	}

	mounted() {
		this.filterByActorType();
	}

	filterByActorType() {
		
		switch(this.entity) {
		case ActorTypes.VOLUNTEER: 
			this.advancedSearch.addSimpleFilter('volunteerid', null);
			break;
		case ActorTypes.ASSOCIATE: 
			this.advancedSearch.addSimpleFilter('associateid', null);
			break;
		case ActorTypes.PATIENT: 
			this.advancedSearch.addSimpleFilter('patientid', null);
			break;
		case ActorTypes.DOCTOR: 
			this.advancedSearch.addSimpleFilter('doctorid', null);
			break;
		}
		
	}

	submit() {
		let url = '';
		if(this.actorSelected) {
			url = this.redirect.replace('*', '' + this.actorSelected.id);
		}
		this.$router.push(url);
	}

}
